import Router from 'vue-router'
import store from './store.js'
import i18n from 'services/i18n'
import { getTrialFormRoute, LINKS, NAMES } from '@/routes'
import Vue from 'vue'

import WatchList from 'views/user/WatchList'
import YourProfile from 'views/user/YourProfile'
import Notes from 'views/user/Notes'
import CompletedCourses from 'views/user/CompletedCourses'
import UncompletedCourses from 'views/user/UncompletedCourses'
import Signups from 'views/user/Signups'
import OrderInfo from 'views/user/OrderInfo'
import Summary from 'views/user/Summary'
import SelfServiceForm from 'views/user/SelfServiceForm'
import Login from 'views/user/Login'
import SSOLoginCallBack from 'views/user/SSOLoginCallBack'
import SSOLoginDedicated from 'views/user/SSOLoginDedicated'
import SSOJoinForm from 'views/SSOJoinForm'

import ResetPassword from 'views/user/ResetPassword'
import SetPassword from 'views/user/SetPassword'
import UserPage from 'views/UserPage'
import OrganizationReport from './views/user/OrganizationReport'

import ItemsList from 'views/ItemsList'
import CollectionPage from 'views/CollectionPage'
import CoursePage from 'views/CoursePage'
import LearningPathPage from 'views/LearningPathPage'

import PageNoPermission from 'views/PageNoPermission'
import PageNotFound from 'views/PageNotFound'
import PageAlreadySignedIn from 'views/PageAlreadySignedIn'
import PageContentExpired from 'views/PageContentExpired'
import PageCurrentlyUnavailable from 'views/PageCurrentlyUnavailable'
import PageSomethingWentWrong from 'views/PageSomethingWentWrong'
import PageUpgradeNotice from 'views/PageUpgradeNotice'

import FreeSubscriptions from 'views/FreeSubscriptions'
import FreeSubscriptionsThankYou from 'views/FreeSubscriptionsThankYou'
import AgreementForm from 'views/AgreementForm'
import LandingPage from 'views/LandingPage'

import AccessibilityStatement from 'views/AccessibilityStatement.vue'

import { viewTypes } from 'store/modules/search'

const SUMMARY = i18n.t('Url.summary')
const COMPLETED = i18n.t('Url.completed')
const UNCOMPLETED = i18n.t('Url.incomplete_courses')
const STUDY_PLANS = i18n.t('Url.study_plans')
const SIGNUPS = i18n.t('Url.signups')
const NOTES = i18n.t('Url.notes')
const USER_PROFILE = i18n.t('Url.user_profile')
const USER_ORDER_INFO = i18n.t('Url.user_order_info')
const CHANGE = i18n.t('Url.change')
const ORGANIZATION_REPORT = i18n.t('Url.organization_report')

const listingsEndpoints = [
    {
        path: LINKS.ALL_PACKAGES_ALL_CONTENT,
        name: 'all-packages-all-content',
        component: ItemsList,
        beforeEnter: onListingItemBeforeEnter(viewTypes.all)
    },
    {
        path: LINKS.ALL_PACKAGES_COURSE_LIST,
        name: 'all-packages-course-list',
        component: ItemsList,
        beforeEnter: onListingItemBeforeEnter(viewTypes.courses)
    },
    {
        path: LINKS.ALL_PACKAGES_COLLECTION_LIST,
        name: 'all-packages-collection-list',
        component: ItemsList,
        beforeEnter: onListingItemBeforeEnter(viewTypes.collections)
    },
    {
        path: LINKS.ALL_PACKAGES_LIVE_EVENTS,
        name: 'all-packages-live-events',
        component: ItemsList,
        beforeEnter: onListingItemBeforeEnter(viewTypes.liveEvents)
    },
    {
        path: LINKS.ALL_PACKAGES_VIRTUAL_CLASSROOMS,
        name: 'all-packages-virtual-classrooms',
        component: ItemsList,
        beforeEnter: onListingItemBeforeEnter(viewTypes.virtualClassrooms)
    },
    {
        path: LINKS.ALL_PACKAGES_LEARNING_PATHS,
        name: 'all-packages-learning-paths',
        component: ItemsList,
        beforeEnter: onListingItemBeforeEnter(viewTypes.learningPaths)
    },
    {
        path: LINKS.ALL_CONTENT,
        name: 'all-content',
        component: ItemsList,
        beforeEnter: onListingItemBeforeEnter(viewTypes.all)
    },
    {
        path: LINKS.COURSE_LIST,
        name: 'course-list',
        component: ItemsList,
        beforeEnter: onListingItemBeforeEnter(viewTypes.courses)
    },
    {
        path: LINKS.COLLECTION_LIST,
        name: 'collection-list',
        component: ItemsList,
        beforeEnter: onListingItemBeforeEnter(viewTypes.collections)
    },
    {
        path: LINKS.LIVE_EVENTS,
        name: 'live-events',
        component: ItemsList,
        beforeEnter: onListingItemBeforeEnter(viewTypes.liveEvents)
    },
    {
        path: LINKS.LEARNING_PATHS,
        name: 'learning-paths',
        component: ItemsList,
        beforeEnter: onListingItemBeforeEnter(viewTypes.learningPaths)
    },
    {
        path: LINKS.VIRTUAL_CLASSROOMS,
        name: 'virtual-classrooms',
        component: ItemsList,
        beforeEnter: onListingItemBeforeEnter(viewTypes.virtualClassrooms)
    },
]

const routes = [
    {
        path: '/',
        name: 'home',
        component: LandingPage
    },
    {
        path: LINKS.SERVICE,
        name: 'home-courses',
        component: LandingPage,
    },
    {
        path: LINKS.COURSE_WITHOUT_PACKAGE,
        name: 'course-without-package',
        component: CoursePage,
        beforeEnter: landingPageBeforeEnter
    },
    {
        path: LINKS.COURSE_WITHOUT_PACKAGE_LIVE,
        name: 'course-without-package-live',
        component: CoursePage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.COURSE_WITHOUT_PACKAGE_VIRTUAL_CLASSROOMS,
        name: 'course-without-package-virtual-classroom',
        component: CoursePage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.COURSE_WITHOUT_PACKAGE_WITH_COLLECTION_SLUG,
        name: 'course-without-package-with-collection-slug',
        component: CoursePage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.COLLECTION_WITHOUT_PACKAGE,
        name: NAMES.COLLECTION_PAGE_WITHOUT_PACKAGE,
        component: CollectionPage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.LEARNING_PATH_WITHOUT_PACKAGE,
        name: NAMES.LEARNING_PATH_PAGE_WITHOUT_PACKAGE,
        component: LearningPathPage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.LOGIN,
        name: 'login',
        component: Login
    },
    {
        path: LINKS.LOGIN_SSO_DEDICATED,
        name: 'login-sso-dedicated',
        component: SSOLoginDedicated
    },
    {
        path: LINKS.LOGIN_SSO_CALLBACK,
        name: 'login-sso-callback',
        component: SSOLoginCallBack
    },
    {
        path: LINKS.SET_PASSWORD,
        name: 'set-password',
        component: SetPassword
    },
    {
        path: LINKS.NEW_PASSWORD,
        name: 'new-password',
        component: ResetPassword
    },
    {
        path: LINKS.PAGE_NOT_FOUND,
        name: 'page-not-found',
        component: PageNotFound
    },
    {
        path: LINKS.PAGE_NO_PERMISSION,
        name: 'page-no-permission',
        component: PageNoPermission
    },
    {
        path: LINKS.PAGE_CONTENT_EXPIRED,
        name: 'page-content-expired',
        component: PageContentExpired
    },
    {
        path: LINKS.PAGE_CURRENTLY_UNAVAILABLE,
        name: 'page-currently-unavailable',
        component: PageCurrentlyUnavailable
    },
    {
        path: LINKS.PAGE_SOMETHING_WENT_WRONG,
        name: 'page-something-went-wrong',
        component: PageSomethingWentWrong
    },
    {
        path: LINKS.PAGE_UPGRADE_NOTICE,
        name: 'page-upgrade-notice',
        component: PageUpgradeNotice
    },
    {
        path: LINKS.PAGE_ALREADY_SIGNED_IN,
        name: 'page-already-signed-in',
        component: PageAlreadySignedIn
    },
    {
        path: LINKS.FREE_SUBSCRIPTIONS,
        name: 'free-subscriptions',
        component: FreeSubscriptions
    },
    {
        path: LINKS.FREE_SUBSCRIPTIONS_THANK_YOU,
        name: 'free-subscriptions-thank-you',
        component: FreeSubscriptionsThankYou
    },
    {
        path: LINKS.AGREEMENT_FORM,
        name: 'agreement-form',
        component: AgreementForm
    },
    {
        path: LINKS.SSO_JOIN,
        name: NAMES.SSO_JOIN,
        component: SSOJoinForm
    },
    {
        path: LINKS.ACCESSIBILITY_STATEMENT,
        name: 'accessibility-form',
        component: AccessibilityStatement
    },
    {
        path: LINKS.USER,
        name: 'user',
        component: UserPage,
        children: [
            {
                path: STUDY_PLANS,
                name: 'user-watchlist',
                component: WatchList,
                beforeEnter: guardAgainstLogin
            },
            {
                path: USER_PROFILE,
                name: 'user-yourprofile',
                component: YourProfile,
                beforeEnter: guardAgainstLogin
            },
            {
                path: NOTES,
                name: 'user-notes',
                component: Notes,
                beforeEnter: guardAgainstLogin
            },
            {
                path: COMPLETED,
                name: 'user-completed',
                component: CompletedCourses,
                beforeEnter: guardAgainstLogin
            },
            {
                path: UNCOMPLETED,
                name: 'user-uncompleted',
                component: UncompletedCourses,
                beforeEnter: guardAgainstLogin
            },
            {
                path: SIGNUPS,
                name: 'user-signups',
                component: Signups,
                beforeEnter: guardAgainstLogin
            },
            {
                path: USER_ORDER_INFO,
                name: 'user-orderinfo',
                component: OrderInfo,
                beforeEnter: guardAgainstLogin
            },
            {
                path: SUMMARY,
                name: 'user-summary',
                component: Summary,
                beforeEnter: guardAgainstLogin
            },
            {
                path: `${USER_PROFILE}/${CHANGE}`,
                name: 'user-selfserviceform',
                component: SelfServiceForm,
                beforeEnter: guardAgainstLogin
            },
            {
                path: ORGANIZATION_REPORT,
                name: 'user-organizationreport',
                component: OrganizationReport,
                beforeEnter: guardAgainstLogin
            }
        ]
    },
    ...listingsEndpoints,
    {
        path: LINKS.COURSE_LIST_COURSE_PAGE,
        name: 'course-list-course-page',
        component: CoursePage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.COURSE_LIST_COURSE_PAGE,
        name: 'course-list-learning-path-page',
        component: LearningPathPage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.COURSE_LIST_COURSE_PAGE_LIVE,
        name: 'course-list-course-page-live',
        component: CoursePage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.COLLECTION_PAGE,
        name: NAMES.COLLECTION_PAGE,
        component: CollectionPage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.COLLECTION_PAGE_COURSE_PAGE,
        name: 'collection-page-course-page',
        component: CoursePage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.COLLECTION_PAGE_COURSE_PAGE_LIVE,
        name: 'collection-page-course-page-live',
        component: CoursePage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.COLLECTION_PAGE_COURSE_PAGE_WITHOUT_PACKAGE,
        name: 'collection-page-course-page-without-package',
        component: CoursePage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.COLLECTION_PAGE_COURSE_PAGE_LIVE_WITHOUT_PACKAGE,
        name: 'collection-page-course-page-live-without-package',
        component: CoursePage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.COLLECTION_PAGE_COURSE_PAGE_VIRTUAL_CLASSROOMS,
        name: 'collection-page-course-page-virtual-classroom',
        component: CoursePage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.COURSE_LIST_COURSE_PAGE_VIRTUAL_CLASSROOMS,
        name: 'course-list-course-page-virtual-classroom',
        component: CoursePage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.COLLECTION_PAGE_COURSE_PAGE_VIRTUAL_CLASSROOMS_WITHOUT_PACKAGE,
        name: 'collection-page-course-page-virtual-classroom-without-package',
        component: CoursePage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.LEARNING_PATH_PAGE,
        name: NAMES.LEARNING_PATH_PAGE,
        component: LearningPathPage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.LEARNING_PATH_PAGE_COURSE_PAGE,
        name: 'learning-path-page-course-page',
        component: CoursePage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.LEARNING_PATH_PAGE_COURSE_PAGE_LIVE,
        name: 'learning-path-page-course-page-live',
        component: CoursePage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.LEARNING_PATH_PAGE_COURSE_PAGE_WITHOUT_PACKAGE,
        name: 'learning-path-course-page-without-package',
        component: CoursePage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.LEARNING_PATH_PAGE_COURSE_PAGE_LIVE_WITHOUT_PACKAGE,
        name: 'learning-path-course-page-live-without-package',
        component: CoursePage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.LEARNING_PATH_PAGE_COURSE_PAGE_VIRTUAL_CLASSROOMS,
        name: 'learning-path-course-page-virtual-classroom',
        component: CoursePage,
        beforeEnter: setScrollPosition
    },
    {
        path: LINKS.LEARNING_PATH_PAGE_COURSE_PAGE_VIRTUAL_CLASSROOMS_WITHOUT_PACKAGE,
        name: 'learning-path-course-page-virtual-classroom-without-package',
        component: CoursePage,
        beforeEnter: setScrollPosition
    },
    {
        path: '/*/',
        beforeEnter: onUnSpecifiedRoute
    }
]

export const globalFromHistory = Vue.observable([])

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior (to, from) {
        Vue.set(globalFromHistory, globalFromHistory.length, from)
        store.dispatch('setPreviousRoutesCount', globalFromHistory.length)
        if (checkIfCourseListViewType(to.name) && store.getters.getScrollPositionForCourseList !== null) {
            const scrollPosition = store.getters.getScrollPositionForCourseList
            store.dispatch('setScrollPosition', null)
            return { y: scrollPosition }
        } else {
            if (!to.name.includes('course-list') && !to.name.includes('collection-page') &&
                !to.name.includes('learning-path-page') && !to.name.includes('without-package')) {
                store.dispatch('setScrollPosition', null)
            }
            return { x: 0, y: 0 }
        }
    },
    routes
})

function onUnSpecifiedRoute (to, from, next) {
    return next({ name: 'page-not-found' })
}

function guardAgainstLogin (to, from, next) {
    if (store.getters.isLoggedIn) {
        return next()
    }
    return next({ name: 'login' })
}

function setScrollPosition (to, from, next) {
    if (checkIfCourseListViewType(from.name)) {
        store.dispatch('setScrollPosition', document.documentElement.scrollTop)
    }
    next()
}

function onListingItemBeforeEnter (viewType) {
    return (to, from, next) => {
        store.dispatch('Search/enableSearch')
        store.dispatch('Search/setViewType', viewType)
        if (from.name === 'home-courses') {
            store.dispatch('Search/setDefaultSortValue')
        }
        next()
    }
}

function landingPageBeforeEnter (to, from, next) {
    if (checkIfCourseListViewType(from.name)) {
        store.dispatch('setScrollPosition', document.documentElement.scrollTop)
    }
    if (from.name === 'home-courses') {
        store.dispatch('Search/setViewType', 'home-courses')
    }
    next()
}

export function isContentListing (Route) {
    return !!listingsEndpoints.find(route => route.name === Route.name)
}

export function checkIfCollectionCoursePage (Route) {
    let routeNames = [
        'collection-page-course-page',
        'collection-page-course-page-live',
        'collection-page-course-page-without-package',
        'collection-page-course-page-live-without-package',
        'learning-path-page-course-page',
        'learning-path-page-course-page-live',
        'learning-path-course-page-without-package',
        'learning-path-course-page-live-without-package'
    ]
    return routeNames.includes(Route)
}

function checkIfCourseListViewType (pathName) {
    let viewTypePathNames = [
        'course-list',
        'virtual-classrooms',
        'live-events',
        'collection-list',
        'all-content',
        'learning-paths',
        'all-packages-course-list',
        'all-packages-live-events',
        'all-packages-collection-list',
        'all-packages-virtual-classrooms',
        'all-packages-all-content'
    ]
    return viewTypePathNames.includes(pathName)
}
